import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { logoutWithModal } from 'modules/auth/actions/logout';
import { getUserFullNameWithMiddleName } from 'modules/user/utils/user';
import { isConversationParticipant } from 'modules/appointmentInfo/selectors/currentAppointment';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { getUsersReadPermissions } from 'modules/session/selectors/permissions';

import AccountDetailsTooltip from './AccountDetailsTooltip';

const mapStateToProps = (state) => {
  const { userId, profile } = state.auth.userInfo;
  const userReadPermissions = getUsersReadPermissions(state);

  return {
    userReadPermissions,
    userId,
    userEmail: profile.email,
    userFullName: getUserFullNameWithMiddleName(profile),
    userIsOnCall: conferenceInProgress(state) && isConversationParticipant(state),
    isMyAccountFeatureEnabled: state.common.organizationConfig.generalConfig.isMyAccountFeatureEnabled,
  };
};

export default connect(
  mapStateToProps,
  { logoutWithModal },
)(injectIntl(AccountDetailsTooltip));
